import { TestCategory } from "types/tests/core";

export const AXIS_KEYS = [
  "problemSolving",
  "readingProcessingSpeed",
  "numericalReasoning",
  "attentionSelfControl",
  "visualTrackingCoordination",
] as const;

export type AxisKey = (typeof AXIS_KEYS)[number];

// Partial because not every TestCategory is part of the cognitive profile —
// only the five that map to a cognitive axis. Using `Partial<Record<...>>`
// makes it explicit that lookups can return undefined for unrelated categories.
export const TEST_CATEGORY_TO_AXIS: Partial<Record<TestCategory, AxisKey>> = {
  [TestCategory.WisconsinCardSorting]: "problemSolving",
  [TestCategory.ReadingAssessment]: "readingProcessingSpeed",
  [TestCategory.Dyscalculia]: "numericalReasoning",
  [TestCategory.ContinuousPerformance]: "attentionSelfControl",
  [TestCategory.OcularMotility]: "visualTrackingCoordination",
};

export type BandDirection = "higherIsBetter" | "lowerIsBetter";

export interface Band {
  metric: string;
  ageMin: number;
  ageMax: number;
  p10: number;
  p25: number;
  p50: number;
  p75: number;
  p90: number;
  direction: BandDirection;
}

export type BandLookup = Partial<Record<TestCategory, Band[]>>;

export interface AxisScore {
  key: AxisKey;
  score: number | null;
  category: TestCategory;
}

export type BandStatus = "excellent" | "typical" | "needsAttention";

export interface PerTestDetail {
  category: TestCategory;
  axis: AxisKey;
  score: number | null;
  status: BandStatus | null;
  metricValues: Record<string, number | null>;
}
